import styled from 'styled-components'

export const Bubble = styled.div<{ $x: number; $y: number }>`
  position: fixed;
  left: ${({ $x }) => $x}px;
  top: ${({ $y }) => $y}px;
  transform: translateX(-50%);
  width: min(80vw, 200px);
  background: #2f3439;
  color: #fff;
  font-weight: 600;
  font-size: 14px;
  line-height: 1.25;
  padding: 12px 40px 12px 24px;
  border-radius: 24px;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.25);
  text-align: center;
  z-index: 1002;
  pointer-events: auto;

  &::before {
    content: '';
    position: absolute;
    top: -25px;
    left: 50%;
    transform: translateX(-50%);
    border: 14px solid transparent;
    border-bottom-color: #2f3439;
  }

  @media (min-width: 768px) {
    left: max(120px, ${({ $x }) => $x}px);
    transform: translateX(0);
  }
`

export const CloseButton = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;
  width: 26px;
  height: 26px;
  border: none;
  background: transparent;
  color: #9aa0a6;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  border-radius: 50%;

  &:hover {
    color: #fff;
    background: rgba(255, 255, 255, 0.08);
  }

  &:focus-visible {
    outline: 2px solid #7aa2ff;
    outline-offset: 2px;
  }
`
